/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetNeighborhoodsNewSignupsPauseStatusRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetNeighborhoodsNewSignupsPauseStatusResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getNeighborhoodsNewSignupsPauseStatus = (request: GetNeighborhoodsNewSignupsPauseStatusRequest, options?: CashRequestOptions) => post<GetNeighborhoodsNewSignupsPauseStatusRequest, GetNeighborhoodsNewSignupsPauseStatusResponse>("/2.0/cash/get-neighborhoods-new-signups-pause-status", request, {...options, rejectOnError: true })